import {LavoratorePresenzeRecord} from "@commons/mapping/LavoratorePresenzeRecord";
import {PVAFormData} from "@commons/mapping/PVAFormData";

export type MiniLavoratore = Pick<LavoratorePresenzeRecord, 'id' | 'cognome' | 'nome' | 'codiceFiscale' |
    'sesso' |
    'codTipologiaContratto' |
    'codCDIC' |
    'codQualifica' |
    'codMansione' |
    'codRuolo' |

    'codGruppo1' |
    'codGruppo2' |
    'codGruppo3' |
    'codGruppo4' |
    'codGruppo5' |
    'codGruppo6' |
    'codGruppo7' |
    'codGruppo8' |
    'codGruppo9' |
    'codGruppo10' |
    'codGruppo11' |
    'codGruppo12'>;

export const lavoratori2MiniLavoratori = (lavoratori: LavoratorePresenzeRecord[]): MiniLavoratore[] => {
    const miniLavoratori: MiniLavoratore[] = [];
    for (const {
        id, cognome, nome, codiceFiscale,
        sesso,
        codTipologiaContratto,
        codCDIC,
        codQualifica,
        codMansione,
        codRuolo,

        codGruppo1,
        codGruppo2,
        codGruppo3,
        codGruppo4,
        codGruppo5,
        codGruppo6,
        codGruppo7,
        codGruppo8,
        codGruppo9,
        codGruppo10,
        codGruppo11,
        codGruppo12
    } of lavoratori) {
        miniLavoratori.push({
            id, cognome, nome, codiceFiscale,
            sesso,
            codTipologiaContratto,
            codCDIC,
            codQualifica,
            codMansione,
            codRuolo,

            codGruppo1,
            codGruppo2,
            codGruppo3,
            codGruppo4,
            codGruppo5,
            codGruppo6,
            codGruppo7,
            codGruppo8,
            codGruppo9,
            codGruppo10,
            codGruppo11,
            codGruppo12
        });
    }
    return miniLavoratori;
}

export const checkPVAFilter = (sp: PVAFormData, element: MiniLavoratore, _index: number, _array: MiniLavoratore[]) => {
    let valid: boolean = true;
    if (sp) {
        if (sp.cdic && sp.cdic.length) {
            valid = valid && !!sp.cdic.find(value => value === element.codCDIC);
        }
        if (sp.mansione && sp.mansione.length) {
            valid = valid && !!sp.mansione.find(value => value === element.codMansione);
        }
        if (sp.ruolo && sp.ruolo.length) {
            valid = valid && !!sp.ruolo.find(value => value === element.codRuolo);
        }
        if (sp.qualifica && sp.qualifica.length) {
            valid = valid && !!sp.qualifica.find(value => value === element.codQualifica);
        }
        if (sp.contratti && sp.contratti.length) {
            valid = valid && !!sp.contratti.find(value => value === element.codTipologiaContratto);
        }
        if (sp.generi && sp.generi.length) {
            valid = valid && !!sp.generi.find(value => value === element.sesso);
        }

        if (sp.gruppo01 && sp.gruppo01.length) {
            valid = valid && !!sp.gruppo01.find(value => value === element.codGruppo1);
        }
        if (sp.gruppo02 && sp.gruppo02.length) {
            valid = valid && !!sp.gruppo02.find(value => value === element.codGruppo2);
        }
        if (sp.gruppo03 && sp.gruppo03.length) {
            valid = valid && !!sp.gruppo03.find(value => value === element.codGruppo3);
        }
        if (sp.gruppo04 && sp.gruppo04.length) {
            valid = valid && !!sp.gruppo04.find(value => value === element.codGruppo4);
        }
        if (sp.gruppo05 && sp.gruppo05.length) {
            valid = valid && !!sp.gruppo05.find(value => value === element.codGruppo5);
        }
        if (sp.gruppo06 && sp.gruppo06.length) {
            valid = valid && !!sp.gruppo06.find(value => value === element.codGruppo6);
        }
        if (sp.gruppo07 && sp.gruppo07.length) {
            valid = valid && !!sp.gruppo07.find(value => value === element.codGruppo7);
        }
        if (sp.gruppo08 && sp.gruppo08.length) {
            valid = valid && !!sp.gruppo08.find(value => value === element.codGruppo8);
        }
        if (sp.gruppo09 && sp.gruppo09.length) {
            valid = valid && !!sp.gruppo09.find(value => value === element.codGruppo9);
        }
        if (sp.gruppo10 && sp.gruppo10.length) {
            valid = valid && !!sp.gruppo10.find(value => value === element.codGruppo10);
        }
        if (sp.gruppo11 && sp.gruppo11.length) {
            valid = valid && !!sp.gruppo11.find(value => value === element.codGruppo11);
        }
        if (sp.gruppo12 && sp.gruppo12.length) {
            valid = valid && !!sp.gruppo12.find(value => value === element.codGruppo12);
        }
    }
    return valid;
}